declare var require: any


// Require
require('bootstrap')
require('bootstrap/dist/css/bootstrap.css')
require('admin-lte')
require('font-awesome/css/font-awesome.css')
require('../libs/icheck/skins/all.css')
require('../libs/icheck/icheck.js')
require('admin-lte/dist/css/AdminLTE.css')
require('admin-lte/dist/css/alt/AdminLTE-bootstrap-social.css')
require('admin-lte/dist/img/avatar5.png')
require('admin-lte/dist/css/skins/skin-green.css')
require('admin-lte/dist/css/skins/_all-skins.css')
require('moment')
require('moment-timezone')
require('bootstrap-daterangepicker')
require('bootstrap-daterangepicker/daterangepicker.css')
require('vue-snotify/styles/material.css')
const isPlainObject = require('lodash/isPlainObject')
// Imports
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './index.vue'
import Auth from './services/auth.js'
import Rest from './services/rest.js'
import VueI18n from 'vue-i18n'
import { store } from './store/store'
import enlang from './lang/en.js'
import sllang from './lang/sl.js'
import router from './router/router'
import Rx from 'rxjs/Rx'
import VueRx from 'vue-rx'
import GSignInButton from 'vue-google-signin-button'
import recaptcha from 'vue-recaptcha'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import Snotify from 'vue-snotify'
import VueBreadcrumbs from 'vue-breadcrumbs'
import VModal from 'vue-js-modal'
import moment from 'moment'
import momentTZ from 'moment-timezone'
import VueObserveVisibility from "vue-observe-visibility"
import $ from 'jquery'

// Plugins
Vue.use(VueBreadcrumbs, {
  template: `<ol class="breadcrumb" v-if="$breadcrumbs.length">
    <li v-for="(crumb, key) in $breadcrumbs">
    <!--<span v-if="key > 0"> / </span>-->
    <!-- <span>{{JSON.stringify(crumb, 1)}}</span>-->
    <router-link class="breadcrumb-item" :to="linkProp(crumb)" :key="key">{{ $t($options.filters.crumbText(crumb)) | stripHtml  }}</router-link>
    </li>
    <li v-for="bread in this.$store.getters.getBreadCrumbs">
    <router-link :to="{ name: 'exercises', params: {gid: bread.groupId, yid: bread.yearId, sid: bread.subgroupId}}">
     {{ bread.name | pickTranslation | stripHtml }}
     </router-link>
    </li>
    <li v-for="bread in this.$store.getters.getAdminBreadCrumbs">
     <router-link :to="{ name: bread.path }">
      {{ bread.name | pickTranslation | stripHtml  }}
     </router-link>
     </li>
    </ol>`
})
Vue.use(VueLodash, lodash)
Vue.use(recaptcha)
Vue.use(GSignInButton)
Vue.use(VueI18n)
Vue.use(Auth)
Vue.use(Rest)
Vue.use(VueRx, Rx)
Vue.use(Snotify)
Vue.use(VModal)
Vue.use(BootstrapVue)
Vue.use(VueObserveVisibility)

Vue.filter('pickTranslation', function (translationObject: any) {
  if (!isPlainObject(translationObject)) return translationObject
  let curLng = store.getters.getCurrentLanguage
  let returnedTranslation = 'Missing translation'
  if (curLng in translationObject) {
    returnedTranslation = translationObject[curLng]
  } else if ('en-us' in translationObject) {
    returnedTranslation = translationObject['en-us']
  } else {
    for (let key in translationObject) {
      if (!translationObject.hasOwnProperty(key)) continue
      returnedTranslation = translationObject[key]
    }
  }
  return returnedTranslation
})

Vue.filter('formatDate', function (input: any) {
  if (!input) return ''
  let formattedDate = momentTZ.tz(input, 'UTC')
  formattedDate = formattedDate.tz('Europe/Ljubljana').format('DD/MM/YYYY HH:mm')
  return formattedDate
})

Vue.filter('stripHtml', function (input: any) {
  return input.replace(/<(?:.|\n)*?>/gm, '')
})
// Vue.use(vueLogger, { prefix: new Date(), dev: true, levels: ['warn', 'debug', 'log', 'error'] })

Vue.config.productionTip = false

router.beforeEach(
  (to:any, from:any, next:any) => {

    // hide all modals after moving to a new route
    $('.modal').modal('hide');

    if (store.getters && store.getters.hasAdminRole == 1) {
          
      if (to.path.includes('home') && !to.path.includes('profile')) {
        next({name: 'adminGroups'})
      }
    }

    if (from.name !== to.name || (from.name === 'exercisesAdmin' && to.name === 'exercises')) {
      store.commit('updateSubgroupsBreadcrumbs', [])
      store.commit('updateAdminBreadcrumbs', [])
    }
    if (to.matched.some((record:any) => record.meta.forVisitors)) {
      if (Auth.isAuthenticated()) {
        next({name: 'groupList'})
      } else {
        next()
      }
    } else if (to.matched.some((record:any) => record.meta.forAuth)) {
      if (Auth.isAuthenticated()) {
        if (from.fullPath.startsWith('/admin') && to.name === 'exercises') {
          next({name: 'exercisesAdmin', params: to.params})
        } else if (from.fullPath.startsWith('/admin') && to.name === 'classExam') {
          next({name: 'classExamAdmin', params: to.params})
        } else {
          next()
        }
      } else {
        next({name: 'home'})
      }
    } else {
      next()
    }
  },
)

const locales = {
  en: enlang,
  sl: sllang
}

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: locales // set locale messages
})



/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  // @ts-ignore
  store,
  router,
  template: '<App/>',
  components: { App },
  i18n
})

// @ts-ignore
vm.$rest.Vue = vm
// @ts-ignore
Vue.vm = vm
// @ts-ignore
window.vm = vm




// WEBPACK FOOTER //
// ./src/main.ts